var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-content page-profile" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c("div", { staticClass: "card" }, [
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _c(
                "tabs",
                { staticClass: "tabs-default" },
                [
                  _c("tab", { attrs: { id: "profile", name: "Profile" } }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-sm-3" }, [
                        _c("div", { staticClass: "avatar-container" }, [
                          _c("img", {
                            staticClass: "img-fluid",
                            attrs: {
                              src: "/assets/img/avatars/avatar-lg.png",
                              alt: "Admin Avatar"
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-9" }, [
                        _c("h4", [_vm._v("Jane Doe")]),
                        _vm._v(" "),
                        _c("p", { staticClass: "detail-row" }, [
                          _c("i", {
                            staticClass: "icon-fa icon-fa-map-marker"
                          }),
                          _vm._v(" New York , United States")
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "detail-row" }, [
                          _c("i", {
                            staticClass: "icon-fa icon-fa-birthday-cake"
                          }),
                          _vm._v(" September 7, 1991")
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "detail-row" }, [
                          _c("i", { staticClass: "icon-fa icon-fa-wrench" }),
                          _vm._v(" UI Designer / Pro Model")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-4" }, [
                      _c("div", { staticClass: "col-sm-12" }, [
                        _c("h3", { staticClass: "section-semi-title" }, [
                          _vm._v("Recent Activity")
                        ]),
                        _vm._v(" "),
                        _c("ul", { staticClass: "media-list activity-list" }, [
                          _c("li", { staticClass: "media" }, [
                            _c("div", { staticClass: "media-left" }, [
                              _c("a", { attrs: { href: "#" } }, [
                                _c("img", {
                                  staticClass: "media-object img-thumbnail",
                                  attrs: {
                                    src: "/assets/img/avatars/avatar1.png",
                                    alt: "Generic placeholder image"
                                  }
                                })
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "media-body" }, [
                              _c("h4", { staticClass: "media-heading" }, [
                                _vm._v(
                                  "\n                          Shane White "
                                ),
                                _c("span", [_vm._v("just posted an update")])
                              ]),
                              _vm._v(" "),
                              _c("small", [_vm._v("Today at 3.50pm")]),
                              _vm._v(" "),
                              _c("p", { staticClass: "mt-2" }, [
                                _vm._v(
                                  '"Hello Everyone! Its been a fun morning!"'
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("li", { staticClass: "media" }, [
                            _c("div", { staticClass: "media-left" }, [
                              _c("a", { attrs: { href: "#" } }, [
                                _c("img", {
                                  staticClass: "media-object img-thumbnail",
                                  attrs: {
                                    src: "/assets/img/avatars/avatar2.png",
                                    alt: "Generic placeholder image"
                                  }
                                })
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "media-body" }, [
                              _c("h4", { staticClass: "media-heading" }, [
                                _vm._v(
                                  "\n                          Adam David "
                                ),
                                _c("span", [
                                  _vm._v("just became friends with")
                                ]),
                                _vm._v(" Shane White\n                        ")
                              ]),
                              _vm._v(" "),
                              _c("small", [_vm._v("Yesterday at 9pm")])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tab",
                    { attrs: { id: "profile-messages", name: "Messages" } },
                    [
                      _c("ul", { staticClass: "media-list activity-list" }, [
                        _c("li", { staticClass: "media" }, [
                          _c("div", { staticClass: "media-left" }, [
                            _c("a", { attrs: { href: "#" } }, [
                              _c("img", {
                                staticClass: "media-object img-thumbnail",
                                attrs: {
                                  src: "/assets/img/avatars/avatar1.png",
                                  alt: "Generic placeholder image"
                                }
                              })
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "media-body" }, [
                            _c("h4", { staticClass: "media-heading" }, [
                              _vm._v("\n                      Adam David "),
                              _c("span", [_vm._v("sent a message")])
                            ]),
                            _vm._v(" "),
                            _c("small", [_vm._v("Today at 3.50pm")]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt-2" }, [
                              _vm._v(
                                "\"When you have children, you always have family. They will always be your priority, your responsibility.\n                    And a man, a man provides. And he does it even when he's not appreciated or respected or even loved. He simply bears up and he does it. Because he's a man.\"\n                    "
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "media" }, [
                          _c("div", { staticClass: "media-left" }, [
                            _c("a", { attrs: { href: "#" } }, [
                              _c("img", {
                                staticClass: "media-object img-thumbnail",
                                attrs: {
                                  src: "/assets/img/avatars/avatar2.png",
                                  alt: "Generic placeholder image"
                                }
                              })
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "media-body" }, [
                            _c("h4", { staticClass: "media-heading" }, [
                              _vm._v("Shane White "),
                              _c("span", [_vm._v("sent a message")])
                            ]),
                            _vm._v(" "),
                            _c("small", [_vm._v("Yesterday at 9pm")]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt-2" }, [
                              _vm._v(
                                "\n                      “Hey! How you doin?”\n                    "
                              )
                            ])
                          ])
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "tab",
                    { attrs: { id: "profile-friends", name: "Friends" } },
                    [
                      _c("ul", { staticClass: "media-list friends-list" }, [
                        _c("li", { staticClass: "media" }, [
                          _c("div", { staticClass: "media-left" }, [
                            _c("a", { attrs: { href: "#" } }, [
                              _c("img", {
                                staticClass: "media-object",
                                attrs: {
                                  src: "/assets/img/avatars/avatar1.png",
                                  alt: "Generic placeholder image"
                                }
                              })
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "media-body" }, [
                            _c("h4", { staticClass: "media-heading" }, [
                              _vm._v("Shane White")
                            ]),
                            _vm._v(" "),
                            _c("small", [_vm._v("2000 friends")])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "media" }, [
                          _c("div", { staticClass: "media-left" }, [
                            _c("a", { attrs: { href: "#" } }, [
                              _c("img", {
                                staticClass: "media-object",
                                attrs: {
                                  src: "/assets/img/avatars/avatar2.png",
                                  alt: "Generic placeholder image"
                                }
                              })
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "media-body" }, [
                            _c("h4", { staticClass: "media-heading" }, [
                              _vm._v("Adam David")
                            ]),
                            _vm._v(" "),
                            _c("small", [_vm._v("200 friends")])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "media" }, [
                          _c("div", { staticClass: "media-left" }, [
                            _c("a", { attrs: { href: "#" } }, [
                              _c("img", {
                                staticClass: "media-object",
                                attrs: {
                                  src: "/assets/img/avatars/avatar3.png",
                                  alt: "Generic placeholder image"
                                }
                              })
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "media-body" }, [
                            _c("h4", { staticClass: "media-heading" }, [
                              _vm._v("Shane White")
                            ]),
                            _vm._v(" "),
                            _c("small", [_vm._v("2000 friends")])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "media" }, [
                          _c("div", { staticClass: "media-left" }, [
                            _c("a", { attrs: { href: "#" } }, [
                              _c("img", {
                                staticClass: "media-object",
                                attrs: {
                                  src: "/assets/img/avatars/avatar4.png",
                                  alt: "Generic placeholder image"
                                }
                              })
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "media-body" }, [
                            _c("h4", { staticClass: "media-heading" }, [
                              _vm._v("Adam David")
                            ]),
                            _vm._v(" "),
                            _c("small", [_vm._v("200 friends")])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "media" }, [
                          _c("div", { staticClass: "media-left" }, [
                            _c("a", { attrs: { href: "#" } }, [
                              _c("img", {
                                staticClass: "media-object",
                                attrs: {
                                  src: "/assets/img/avatars/avatar5.png",
                                  alt: "Generic placeholder image"
                                }
                              })
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "media-body" }, [
                            _c("h4", { staticClass: "media-heading" }, [
                              _vm._v("Shane White")
                            ]),
                            _vm._v(" "),
                            _c("small", [_vm._v("2000 friends")])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "media" }, [
                          _c("div", { staticClass: "media-left" }, [
                            _c("a", { attrs: { href: "#" } }, [
                              _c("img", {
                                staticClass: "media-object",
                                attrs: {
                                  src: "/assets/img/avatars/avatar6.png",
                                  alt: "Generic placeholder image"
                                }
                              })
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "media-body" }, [
                            _c("h4", { staticClass: "media-heading" }, [
                              _vm._v("Adam David")
                            ]),
                            _vm._v(" "),
                            _c("small", [_vm._v("200 friends")])
                          ])
                        ])
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("h3", { staticClass: "page-title" }, [_vm._v("User Profile")]),
      _vm._v(" "),
      _c("ol", { staticClass: "breadcrumb" }, [
        _c("li", { staticClass: "breadcrumb-item" }, [
          _c("a", { attrs: { href: "#" } }, [_vm._v("Home")])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "breadcrumb-item" }, [
          _c("a", { attrs: { href: "#" } }, [_vm._v("Users")])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "breadcrumb-item active" }, [
          _vm._v("Jane Doe")
        ])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e04b38da", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e04b38da","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/admin/users/Profile.vue
// module id = 826
// module chunks = 0